import { StyleSheet } from 'react-native';

import { isTabletOrWeb } from 'utils/responsiveness';

const styles = StyleSheet.create({
    text: {
        paddingTop: 18,
        paddingBottom: 6,
        paddingHorizontal: 16,
    },
    marker: {
        marginRight: isTabletOrWeb ? 12 : 8,
    },
    contentContainer: {
        paddingLeft: 16,
        paddingBottom: 8,
    },
});

export default styles;
